module.exports = __webpack_public_path__ + "static/Find Us Store 7-01-bd3891096236e149a35da4e8f9fb134e.png";